var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mailling-recipients-col"},[_c('filters-list',{attrs:{"filters":_vm.row.getFilter(),"size":"small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }